export default "__VITE_ASSET__BlMk09Af__"